import { createSlice } from "@reduxjs/toolkit"


const productSlice = createSlice({
  name: "product",
  initialState: {


    product: null,
    products: null,
    filteredProducts: null,
    filter: {
      search: null,
      pagination: null,

    },
    filterProductCount: [
      10, 50, 100, 200, 300
    ],
    pagination: null,

    selectedProducts: [],

    selectedpagination: 0

  },
  reducers: {

    setProduct(state, action) {
      state.product = action.payload
    },
    setProducts(state, action) {
      state.products = action.payload
    }
    ,
    setFilteredItems(state, action) {
      state.filteredProducts = action.payload
    },
    resetProducts(state){
      state.products = null
      state.filteredProducts = null
      state.filter = {
        search: null,
        pagination: null,
      }
    }

    ,
    setFilter(state, action) {

      if (Array.isArray(action.payload)) {
        action.payload.map(item => {
          state.filter[item.key] = item.value
        })
      }
      else {
        state.filter[action.payload.key] = action.payload.value
      }


    },
    setPagination(state, action) {
      state.pagination = action.payload
    },

    removeProduct(state, action) {

      state.products = state.products.filter(product => product.id !== action.payload)
      if (state.filteredProducts) {
        state.filteredProducts = state.filteredProducts.filter(product => product.id !== action.payload)
      }


    }
    ,
    updateProduct(state, action) {

      action.payload.map(item => {
        state.product[item.key] = item.value
      })


    },

    updateProducts(state, action) {

      Object.keys(state.products).forEach(key => {
        let item = state.products[key]

        action.payload.ids.map(id => {

          if (item.id == id) {

            action.payload.changes.map(ch => {

              if (ch.value !== null) {
                state.products[key][ch.key] = ch.value

              }
            })
          }
        })

      })

      if (state.filteredProducts) {

        Object.keys(state.filteredProducts).forEach(key => {
          let item = state.filteredProducts[key]

          action.payload.ids.map(id => {

            if (item.id == id) {

              action.payload.changes.map(ch => {

                if (ch.value !== null) {
                  state.filteredProducts[key][ch.key] = ch.value

                }
              })
            }
          })

        })


      }

    },

    addProduct(state, action) {
      state.products = [...state.products, action.payload]
      state.filteredProducts = [...state.filteredProducts, action.payload]
    }
    ,
    onSelectProduct(state, action) {
      if (action.payload.action === 'add') {
        state.selectedProducts = [...state.selectedProducts, action.payload.user]
      }
      if (action.payload.action === 'remove') {
        state.selectedProducts = state.selectedProducts.filter(user => user.id !== action.payload.user.id)
      }
    }

    ,

    setSelectedPagination(state, action) {
      state.selectedpagination = action.payload
    },

    resetProducts(state) {

      state.products = null
      state.filteredProducts = null
      state.filter = {
        search: null,
        pagination: null,
      }

    },

  },
});

export default productSlice

export const productActions = productSlice.actions;